import styled from "styled-components";

export const CMCloseButton = styled.div((props) => ({
  textAlign: "right",
  position: "absolute",
  right: 32,
  top: 28,
  cursor: "pointer",
}));

export const CMModalAuctionBook = styled.div((props) => ({
  width: 700,
  [`@media (min-width: 2000px)`]: {
    width: "100%",
   },
  [`@media (max-width: 700px)`]: {
    width: '98%',
  },
}));

export const CMwizardMakeOffer = {
  
};
export const CMwizardConfirmBid = {
  width: 673,
  //height: 780,
  [`@media (min-width: 2000px)`]: {
    width:"100% !important",
 },
};
export const CMwizardOrderConfirmed = {
  minHeight: "auto",
};
export const CMwizardFundsBid = {
  height: 600,
  width: 673,
};
export const CMwizardPaymentMethod = {
  height: 570,
  width: 673,
};
export const CMwizardVisaFunds = {
  height: 570,
  width: 673,
};
export const CMwizardTransactionSuccess = {
  height: 570,
  width: 673,
};

export const CMwizardAuctionBook = {
  overflowY: 'unset',
  width: '95%'
};

export const CMTitleStyle = {
  fontWeight: 500,
  fontSize: 30,
};
export const CMTitleStyleMobile = {
  fontWeight: 500,
  fontSize: 20
}

export const CMwizardConfirmOrder = {
  width: 100,
  height: 780,
};
export const CMWarning = {
  fontWeight: 500,
  fontSize: 30,
  height: 370,
  width: 673,
};
